exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-blanco[data-v-7c73a730] {\n  color: white;\n}\n", ""]);

// exports
